import { ApiError, Unauthenticated } from '../../../api.js';
import { viewFetch } from '../../../view-as.js';
import type { Change, Changes } from '../contract.js';
import { wholePreview, type PreviewAnswer } from '../../whole-preview.js';
import type { PeopleData, Receipt } from './types.js';
async function request<T>(store: string, path = '', body?: unknown, signal?: AbortSignal): Promise<T> {
  const response = await viewFetch(`/api/admin/access${path}${path.includes('?') ? '&' : '?'}store=${encodeURIComponent(store)}`, {
    credentials: 'same-origin', ...(signal ? { signal } : {}), ...(body === undefined ? {} : { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }),
  });
  if (response.status === 401) throw new Unauthenticated();
  // A reply that is not JSON (a 502 from the proxy) shows the search page's words for it, never the browser's parse error.
  const answer = await response.json().catch(() => null);
  if (answer === null) throw new ApiError(response.status, 'the server did not answer');
  if (!response.ok) throw new ApiError(response.status, answer.error);
  return answer as T;
}
export const peopleApi = {
  read: (store: string, signal?: AbortSignal) => request<PeopleData>(store, '', undefined, signal),
  preview: (store: string, change: Change, signal?: AbortSignal) => request<PreviewAnswer>(store, '/preview', { change }, signal).then(wholePreview),
  apply: (store: string, change: Change, reason: string) => request<Receipt>(store, '/apply', { change, reason }),
  changes: (store: string, filters: { person?: string | undefined; group?: string | undefined; before?: string | undefined; limit?: number } = {}, signal?: AbortSignal) => {
    const q = new URLSearchParams({ limit: String(filters.limit ?? 20) });
    if (filters.person) q.set('principal', filters.person);
    if (filters.group) q.set('group', filters.group);
    if (filters.before) q.set('before', filters.before);
    return request<Changes>(store, `/changes?${q}`, undefined, signal);
  },
  takeBackPreview: (store: string, id: string, signal?: AbortSignal) => request<PreviewAnswer>(store, `/changes/${encodeURIComponent(id)}/take-back/preview`, {}, signal).then(wholePreview),
  takeBack: (store: string, id: string, reason: string) => request<Receipt>(store, `/changes/${encodeURIComponent(id)}/take-back`, { reason }),
};
